var map = {
	"./autocomplete_controller.js": 23710,
	"./favorite_controller.js": 48102,
	"./landing_autocomplete_controller.js": 60994,
	"./read-more_controller.js": 65668,
	"./references_controller.js": 11368,
	"./review_controller.js": 55142,
	"./reviews_block_controller.js": 97363,
	"./utils.js": 97062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48312;